!function () {
    var _ = {};
    window.gbcalendar = _;

    let secureDate = function (date) {
        if (moment.isMoment(date)) {
            date = date.toDate();
        }
        let offset = date.getTimezoneOffset();
        date = new Date(+date + (offset * 60000));
        return date;
    };

    let isWithinTimeframe = function (timeframeStart, timeframeEnd, start, end) {
        return !(end < timeframeStart || start > timeframeEnd);
    };

    _.eventSources = (() => {
        let _loadCache = () => {
            let _cache = {};

            if (!window.localStorage) {
                return _cache;
            }

            let _localStorage = window.localStorage.getItem('calendarEvents');

            if (_localStorage && localStorage.length) {
                _cache = JSON.parse(_localStorage);

                for (let key in _cache) {
                    let item = _cache[key];
                    if (!item || !item.data) {
                        delete _cache[key];
                    }
                }
            }
            
            return _cache;
        };
        let _persist = (_cache) => { window.localStorage && window.localStorage.setItem('calendarEvents', JSON.stringify(_cache)); };
        let _clean = (events, ns, start, end) => {
            start = secureDate(start);
            end = secureDate(end);

            let limit = new Date() - 3600000; // one hour
            let output = [];
            let _cache = _loadCache();
            let _eventMap = {};
            let _cleanCount = 0;
            let _limitCount = 0;

            for (var i = 0; i < events.length; i++) {
                let _event = events[i];
                _eventMap[_event.id] = _event;
            }

            if (!ns) {
                for (let key in _cache) {
                    // remove missing events from cache
                    let _c = _cache[key];
                    if (isWithinTimeframe(start, end, moment(`${_c.data.start}`).toDate(), moment(`${_c.data.end}`).toDate()) && !(key in _eventMap)) {
                        output[output.length] = _c;
                        delete _cache[key];
                        ++_cleanCount;
                    }
                }
            } else {
                for (let key in _cache) {
                    // remove missing events from cache
                    let _c = _cache[key];
                    if (_c.data.className === ns && isWithinTimeframe(start, end, moment(`${_c.data.start}`).toDate(), moment(`${_c.data.end}`).toDate()) && !(key in _eventMap)) {
                        output[output.length] = _c;
                        delete _cache[key];
                        ++_cleanCount;
                    }
                }
            }

            for (let key in _cache) {
                if (!_cache.hasOwnProperty(key)) continue;
                let evt = _cache[key];
                if (!+evt.stored || evt.stored < limit) {
                    delete _cache[key];
                    ++_limitCount;
                }
            }

            _limitCount && console.log(`cache@cleaned limit (${_limitCount})`);
            _cleanCount && console.log(`cache@cleaned (${_cleanCount}): [${ns}] ${(new Date(start)).toISOString()} - ${(new Date(end)).toISOString()}`);
            _persist(_cache);
            return output;
        };
        let _store = (events) => {
            let storedDate = new Date();
            let _cache = _loadCache();

            for (let key in events) {
                let evt = events[key];
                _cache[evt.id] = {
                    data: evt,
                    stored: +storedDate
                };
            }

            console.log(`cache@stored (${Object.getOwnPropertyNames(_cache).length})`);
            _persist(_cache);
        };
        let _fetch = (start, end) => {
            start = secureDate(start);
            end = secureDate(end);

            let result = [];
            let limit = new Date() - 3600000; // one hour
            let _cache = _loadCache();
            let _limitCount = 0;

            for (let key in _cache) {
                if (!_cache.hasOwnProperty(key)) continue;
                let evt = _cache[key];
                if (!+evt.stored || evt.stored < limit) {
                    delete _cache[key];
                    ++_limitCount;
                } else {
                    if (isWithinTimeframe(start, end, moment(`${evt.data.start}`).toDate(), moment(`${evt.data.end}`).toDate())) {
                        result[result.length] = evt.data;
                    }
                }
            }
            _limitCount && console.log(`cache@cleaned limit (${_limitCount})`);
            console.log(`cache@loaded (${result.length}): ${(new Date(start)).toISOString()} - ${(new Date(end)).toISOString()}`);
            _persist(_cache);
            return result;
        };

        return {
            update: function (calendar, start, end) {
                let cached = _fetch(start, end);
                if (cached && cached.length) {
                    _.loading.lessons.isFetching =
                        _.loading.blockings.isFetching =
                        _.loading.groups.isFetching =
                        _.loading.shops.isFetching =
                        _.loading.locks.isFetching = true;

                    $.when(calendar.fullCalendar('removeEvents', function (fc_event) {
                        return cached.any((e) => {
                            return e.id === fc_event.id;
                        });
                    })).then(() => {
                        calendar.fullCalendar('renderEvents', cached);
                    });
                    
                    this.all(calendar, true);
                } else {
                    this.all(calendar, false);
                }
            },
            ajax: function (url, ns, calendar, silent) {
                var startDate = new Date();
                let view = calendar.fullCalendar('getView');
                let _data = $.extend(fetchResourcesParams(), fetchLocationsParams(), { start: gb.date.toSortable(view.start.toDate()), end: gb.date.toSortable(view.end.toDate()), timezone: $('select[name=TimeZone] option:selected').val() });
                
                if (!_data ||
                    !_data.start ||
                    !_data.end ||
                    (Object.keys && !Object.keys(_data).any((e) => { return e.indexOf('resources') !== -1; }))) {
                    return;
                }

                $.ajax({
                    url: url,
                    type: 'POST',
                    dataType: 'json',
                    data: _data,
                    async: silent,
                    beforeSend: function (jqXHR) {
                        console.log(`events@loading: [${ns}] ${view.start.toDate().toISOString()} - ${view.start.toDate().toISOString()}`);
                        if (!ns) {
                            _.loading.lessons.isFetching =
                                _.loading.blockings.isFetching =
                                _.loading.groups.isFetching =
                                _.loading.shops.isFetching =
                                _.loading.locks.isFetching = true;

                            _.loading.lessons.lastestFetchDate = new Date(startDate.valueOf());
                            _.loading.blockings.lastestFetchDate = new Date(startDate.valueOf());
                            _.loading.groups.lastestFetchDate = new Date(startDate.valueOf());
                            _.loading.shops.lastestFetchDate = new Date(startDate.valueOf());
                            _.loading.locks.lastestFetchDate = new Date(startDate.valueOf());

                            _.loading.lessons.clearRefetch();
                            _.loading.blockings.clearRefetch();
                            _.loading.groups.clearRefetch();
                            _.loading.shops.clearRefetch();
                            _.loading.locks.clearRefetch();
                        } else {
                            _.loading[ns].lastestFetchDate = new Date(startDate.valueOf());
                            !silent && (_.loading[ns].isFetching = true);
                            _.loading[ns].clearRefetch();
                        }
                        if (!silent) _.loading.update();
                    },
                    success: function (data, textStatus, jqXHR) {
                        if (!ns) {
                            _.loading.lessons.isFetching =
                                _.loading.blockings.isFetching =
                                _.loading.groups.isFetching =
                                _.loading.shops.isFetching =
                                _.loading.locks.isFetching = false;

                            _.loading.lessons.startRefetch();
                            _.loading.blockings.startRefetch();
                            _.loading.groups.startRefetch();
                            _.loading.shops.startRefetch();
                            _.loading.locks.startRefetch();
                        } else {
                            if (+(_.loading[ns].lastestFetchDate) !== +startDate) {
                                return;
                            }

                            _.loading[ns].isFetching = false;
                            _.loading[ns].startRefetch();
                        }

                        if (data && data.length) {
                            console.log(`events@loaded (${data.length}): [${ns}] ${view.start.toDate().toISOString()} - ${view.start.toDate().toISOString()}`);
                            let updated = [];
                            let _cache = _loadCache();

                            for (let key in data) {
                                let _event = data[key];
                                let _fromCache = _cache[_event.id];
                                if (!_fromCache || !_fromCache.data || JSON.stringify(_event) !== JSON.stringify(_fromCache.data)) {
                                    updated[updated.length] = _event;
                                }
                            }

                            let removes = _clean(data, ns, view.start, view.end);

                            setTimeout(function() {
                                $.when(calendar.fullCalendar('removeEvents', function (fc_event) {
                                    let remove =
                                        (updated.any((e) => {
                                            return e.id === fc_event.id;
                                        })
                                            ||
                                        removes.any((e) => {
                                            return e.data.id === fc_event.id;
                                        }));
                                    return remove;
                                })).then(() => {
                                    calendar.fullCalendar('renderEvents', updated);
                                    if (!silent) _.loading.update();
                                });
                            }, 10);

                            console.log(`cache@updated (${updated.length})`);
                            _store(updated);
                        } else {
                            let removes = _clean([], ns, view.start, view.end);
                            setTimeout(() => {
                                calendar.fullCalendar('removeEvents', function (fc_event) {
                                    return removes.any((e) => {
                                        return e.data.id === fc_event.id;
                                    });
                                });
                            });
                        }
                    }
                });
            },
            lessons: function (calendar, silent) {
                this.ajax('/Calendar/GetLessonEventsFromTo', 'lessons', calendar, silent);
            },
            blockings: function (calendar, silent) {
                this.ajax('/Calendar/GetBlockingEventsFromTo', 'blockings', calendar, silent);
            },
            groups: function (calendar, silent) {
                this.ajax('/Calendar/GetCourseEventsFromTo', 'groups', calendar, silent);
            },
            shops: function (calendar, silent) {
                this.ajax('/Calendar/GetShopEventsFromTo', 'shops', calendar, silent);
            },
            locks: function (calendar, silent) {
                this.ajax('/Calendar/GetLocksFromTo', 'locks', calendar, silent);
            },
            all: function (calendar, silent) {
                this.ajax('/Calendar/AllEvents', null, calendar, silent);
            }
        };
    })();

    _.loading = (() => {
        let loading_indicator = null;

        return {
            loadPermissible: function (func, type) {
                let $hover_events = $('.fc-event:hover, .fc-list-item:hover', _.loading.calendar);

                if ($hover_events.length > 0) {
                    $hover_events.off('.loading-' + type).on('mouseout.loading-' + type, function () { $hover_events.off('.loading-' + type); func(); });
                } else {
                    func();
                }
            },
            enabled: true,
            calendar: null,
            lessons: {
                lastestFetchDate: null,
                isFetching: false,
                timeout: null,
                startRefetch: function () {
                    if (_.loading.enabled) {
                        this.timeout = setTimeout(function () {
                            _.loading.loadPermissible(function () { _.eventSources.lessons($(_.loading.calendar), true); }, 'lessons');
                        }, 60000); // 60 sec
                    }
                },
                clearRefetch: function () {
                    clearTimeout(this.timeout);
                }
            },
            blockings: {
                lastestFetchDate: null,
                isFetching: false,
                timeout: null,
                startRefetch: function () {
                    if (_.loading.enabled) {
                        this.timeout = setTimeout(function () {
                            _.loading.loadPermissible(function () { _.eventSources.blockings($(_.loading.calendar), true); }, 'blockings');
                        }, 300000); // 5 min
                    }
                },
                clearRefetch: function () {
                    clearTimeout(this.timeout);
                }
            },
            groups: {
                lastestFetchDate: null,
                isFetching: false,
                timeout: null,
                startRefetch: function () {
                    if (_.loading.enabled) {
                        this.timeout = setTimeout(function () {
                            _.loading.loadPermissible(function () { _.eventSources.groups($(_.loading.calendar), true); }, 'groups');

                        }, 300000); // 5 min
                    }
                },
                clearRefetch: function () {
                    clearTimeout(this.timeout);
                }
            },
            shops: {
                lastestFetchDate: null,
                isFetching: false,
                timeout: null,
                startRefetch: function () {
                    if (_.loading.enabled) {
                        this.timeout = setTimeout(function () {
                            _.loading.loadPermissible(function () { _.eventSources.shops($(_.loading.calendar), true); }, 'shops');
                        }, 60000); // 60 sec
                    }
                },
                clearRefetch: function () {
                    clearTimeout(this.timeout);
                }
            },
            locks: {
                lastestFetchDate: null,
                isFetching: false,
                timeout: null,
                startRefetch: function () {
                    if (_.loading.enabled) {
                        this.timeout = setTimeout(function () {
                            _.loading.loadPermissible(function () { _.eventSources.locks($(_.loading.calendar), true); }, 'locks');
                        }, 60000); // 60 sec
                    }
                },
                clearRefetch: function () {
                    clearTimeout(this.timeout);
                }
            },
            resources: {
                lastestFetchDate: null,
                isFetching: false
            },
            update: function () {
                if (!loading_indicator || !loading_indicator.length) {
                    loading_indicator = $('#calendarLoadingIndicator');

                    if (!loading_indicator || !loading_indicator.length) {
                        loading_indicator = $(_.loading.calendar).find('.fc-header-toolbar .fc-right').prepend('<span id="calendarLoadingIndicator" class="hidden"></span>').find('#calendarLoadingIndicator');
                    }
                }

                let isFetching =
                    this.lessons.isFetching ||
                    this.blockings.isFetching ||
                    this.groups.isFetching ||
                    this.shops.isFetching ||
                    this.locks.isFetching ||
                    this.resources.isFetching;

                if (!isFetching) {
                    gb.ui.spinner.hide($('.loadingSpinner', _.loading.calendar));
                } else {
                    gb.ui.spinner.show($('.loadingSpinner', _.loading.calendar));
                }

                loading_indicator.toggleClass('hidden', !isFetching);

                return isFetching;
            }
        };
    })();

    var isAdmin = false;
    var economyEnabled = false;
    var backgroundColors = ['#16A085', '#F39C12', '#27AE60', '#C0392B', '#E67E22', '#8E44AD', '#8E44AD', '#D14EC0'];
    var calendarFilters = null;
    var fetchLocationsParams = function () {
        var data = {};

        $('select[name="locations"] option:not([value="null"]):selected').each(function (i) {
            data["locations[" + i + "]"] = this.value;
        });

        return data;
    };
    var fetchResourcesParams = function () {
        var data = {};

        $('select[name="resources"] option:selected').each(function (i) {
            data["resources[" + i + "]"] = this.value;
        });

        return data;
    };
    var calendarOptions = function (calendarID) {
        var localeFormats = {
            shortDate: null
        };

        return {
            schedulerLicenseKey: '0451907029-fcs-1517999442',
            lazyFetching: true,
            height: 'auto',
            defaultView: 'agendaWeek',
            editable: isAdmin,
            selectable: true,
            allDaySlot: false,
            locale: 'en',
            fixedWeekCount: false,
            navLinks: true,
            navLinkWeekClick: 'agendaWeek',
            navLinkDayClick: 'agendaDay',
            listDayFormat: 'dddd',
            listDayAltFormat: 'DD. MMMM YYYY',
            selectHelper: isAdmin,
            selectConstraint: isAdmin ? undefined : 'businessHours',
            unselectAuto: true,
            header: {
                left: 'prev today',
                center: 'title',
                right: 'next'
            },
            footer: {
                left: (isAdmin ? 'agendaDay,agendaTwoDay,agendaWeek,month gbListDay,gbListWeek' : ''),
                right: (isAdmin ? 'calendarIntegration' : '')
            },
            columnHeaderText: function (_moment) {
                var format = localeFormats.shortDate || (localeFormats.shortDate = 'ddd ' + _moment.localeData().longDateFormat('l').replace(/Y/g, '').replace(/^\W|\W$|\W\W/, ''));
                return _moment.format(format);
            },
            views: {
                agendaDay: {
                    type: 'agenda',
                    duration: { days: 1 },
                    buttonText: '1 ' + translator.translate('day', 'Day'),
                    titleFormat: 'dddd - D. MMM. YYYY'
                },
                agendaTwoDay: {
                    type: 'agenda',
                    duration: { days: 2 },
                    buttonText: '2 ' + translator.translate('days', 'Days')
                },
                gbListDay: {
                    type: 'list',
                    duration: { days: 1 },
                    buttonText: translator.translate('list_day', 'List day'),
                    titleFormat: 'D. MMM. YYYY W'
                },
                gbListWeek: {
                    type: 'list',
                    duration: { week: 1 },
                    buttonText: translator.translate('list_week', 'List week'),
                    titleFormat: 'D. MMM. YYYY W'
                },
                gbTimelineDay: {
                    type: 'timeline',
                    duration: { day: 1 },
                    buttonText: translator.translate('timeline_day', 'Timeline day'),
                }
            },
            customButtons: {
                calendarIntegration: {
                    text: translator.translate('calendarintegration', 'Calendarintegration'),
                    click: function (jqEvent) {
                        window.location.href = `https://${window.location.host}/Pro/iCalendar/GetFeed/${$('select[name="resources"] option:selected').first().val()}`;
                        gb.ui.spinner.hide($('.loadingSpinner'));
                    }
                }
            },
            windowResize: function (view) {
                // https://fullcalendar.io/docs/current_date/duration/
                // https://fullcalendar.io/docs/views/changeView/
            },
            selectOverlap: function (event) {
                return event.rendering === 'background' || !event.resourceId || event.overlap;
            },
            eventOverlap: function (stillEvent, movingEvent) {
                return stillEvent.rendering === 'background' || !stillEvent.resourceId || stillEvent.overlap;
            },
            selectAllow: function (selectInfo) {
                if (isAdmin || selectInfo.start.diff(moment().stripZone()) > 0) {
                    return true;
                } else {
                    console.log('past!');
                    return false;
                }
            },
            select: function (start, end, jsEvent, view, resource) {
                $("#newAppointmentTime-date").html(start.format('Do MMMM YYYY'));
                $("#newAppointmentTime-time-start").html(start.format(FullCalendar.locales[$(calendarID).fullCalendar('option', 'locale')].mediumTimeFormat));

                let $calendar = $(calendarID);
                let start_as_date = start.toDate();
                let events = $calendar.fullCalendar('getResourceEvents', resource).filter(e => { return e.start.toDate() > start_as_date && e.rendering !== 'background'; });
                let $modal = $('#createNewAppointmentModal');
                let $null_option = $('select[name="lesson"] option[value="null"]').addClass('hidden').attr('disabled', true);
                let $lesson_options = $('select[name="lesson"] option:not([value="null"])', $modal).attr({ 'disabled': false, 'checked': false }).trigger('change');
                let $ok_button = $null_option.parents('#createNewAppointmentModal').find('.ok-button').removeAttr('disabled');
                let $lesson_radio = $('input[name="appointment_type"][value="lesson"]').removeClass('no-submit');
                let disabled_lessons = 0;
                let bh_end = null;
                let bh_clicked = null;

                let dow = start.day();
                for (let i = 0; i < resource.businessHours.length; i++) {
                    let bh = resource.businessHours[i];
                    if (bh.dow.any(e => e == dow) && moment(bh.startAsISO).stripZone().diff(start) <= 0 && moment(bh.endAsISO).stripZone().diff(start) > 0) {
                        // selected inside this businesshour
                        bh_clicked = bh;
                        bh_end = moment(bh.endAsISO).stripZone();
                        break;
                    }
                }

                if ($calendar.hasClass('rebooking')) {
                    window.location.href = "/Pro/Calendar/Appointment/" + $calendar.data('rebooking') + "/Rebook/" + gb.date.toSortable(start.toDate()) + "/" + resource.id + "/" + $('select[name=TimeZone] option:selected').val();
                    return false;
                }


                // Everything is reset before this point
                for (let i = 0; i < $lesson_options.length; i++) {
                    let option = $lesson_options[i];
                    let lesson_resources = $(option).data('resources').split(',');
                    let lesson_duration = $(option).data('calendar-duration');
                    let lesson_end = moment(start).add(parseInt(lesson_duration), 'minutes');

                    let option_has_resource = false;
                    for (let j = 0; j < lesson_resources.length; j++) {
                        if (resource.id === lesson_resources[j]) {
                            option_has_resource = true;
                        }
                    }
                    $(option).toggleClass('hidden', !option_has_resource);

                    if (!isAdmin && lesson_end > bh_end) {
                        $(option).attr('disabled', true);
                        disabled_lessons++;
                        continue;
                    }

                    for (let j = 0; j < events.length; j++) {
                        if (lesson_end > events[j].start) {
                            $(option).attr('disabled', true);
                            disabled_lessons++;
                            break;
                        }
                    }
                    if (bh_clicked && !($(option).data('locations').toLowerCase().indexOf(bh_clicked.locationId) >= 0)) {
                        $(option).attr('disabled', true);
                    }
                }

                $modal.removeClass('hidden');


                if (disabled_lessons === $lesson_options.length) { // No lessons bookable
                    $null_option.removeClass('hidden').attr({ 'disabled': false, 'selected': true }).prop({ 'disabled': false, 'selected': true });
                    $ok_button.attr('disabled', true);
                    $('input[name="appointment_type"][value="lesson"]').addClass('no-submit');
                } else if ($lesson_options && $lesson_options.length) {
                    let first_lesson = $lesson_options.not('[disabled], .hidden').first();
                    $lesson_options.parent().val(first_lesson.val());

                    let lesson_duration = first_lesson.data((isAdmin ? 'calendar-duration' : 'duration'));
                    $("#newAppointmentTime-time-end").html(moment(start).add(parseInt(lesson_duration), 'minutes').format(FullCalendar.locales[$(calendarID).fullCalendar('option', 'locale')].mediumTimeFormat));
                }

                $('select[name="lesson"]').off('change').on('change', (function (_start) {
                    return function () {
                        let lesson_duration = $('option[value="' + this.value + '"]', this).data((isAdmin ? 'calendar-duration' : 'duration'));
                        $("#newAppointmentTime-time-end").html(moment(_start).add(parseInt(lesson_duration), 'minutes').format(FullCalendar.locales[$(calendarID).fullCalendar('option', 'locale')].mediumTimeFormat));
                    };
                })(start));

                setTimeout(function () { $('select[name="lesson"]').focus(); }, 100);

                $('#createAppointmentButton').off('click').on('click', (function (_start, _end, _resource) {
                    return function () {
                        let $self = $(this);
                        if (!$self.is('[disabled]')) {
                            let app_type = $('input[name="appointment_type"]:checked');
                            let url = '/';
                            let from = gb.date.toSortable(_start.toDate());
                            let to = gb.date.toSortable(_end.toDate());

                            switch (app_type.val()) {
                                default:
                                case 'lesson':
                                    to = gb.date.toSortable(moment(start).add(parseInt($('select[name="lesson"] option:selected').data('calendar-duration')), 'minutes').toDate());
                                    if (isAdmin) {
                                        url += `Pro/Calendar/AppointmentLesson/${_resource.id}/${from}/${to}/${$('select[name="lesson"]').val()}/${$('select[name=TimeZone] option:selected').val()}`;
                                    } else {
                                        url += `Player/Bookings/${_resource.id}/${from}/${to}/${$('select[name="lesson"]').val()}/${$('select[name="locations"] option:selected').val()}`;
                                    }
                                    if (bh_clicked) {
                                        $.ajax({
                                            url: '/Calendar/Lock',
                                            method: 'POST',
                                            dataType: 'json',
                                            data: {
                                                resourceGuid: resource.id,
                                                start: from,
                                                end: to,
                                                timezone: $('select[name=TimeZone] option:selected').val()
                                            },
                                            complete: function (jqXHR) {
                                                if ((jqXHR && jqXHR.status === 200 && jqXHR.responseJSON) && (!jqXHR.responseJSON.IsAuthenticated || jqXHR.responseJSON.Success)) {
                                                    window.location.href = url;
                                                }
                                            }
                                        });
                                    } else {
                                        window.location.href = url;
                                    }
                                    break;
                                case 'group_lesson':
                                    url += `Pro/Calendar/Course/Edit/${from}/${to}/${_resource.id}/${$('select[name=TimeZone] option:selected').val()}`;

                                    if (bh_clicked !== null) {
                                        url += `/${bh_clicked.locationId}`;
                                    }
                                    window.location.href = url;
                                    break;
                                case 'blocking':
                                    let blocking_type = $('input[name="blocking_option"]:checked').val();

                                    if (blocking_type === 'quick_blocking') {
                                        url += `Pro/Calendar/Blocking/Quick/${from}/${to}/${_resource.id}/${$('select[name=TimeZone] option:selected').val()}`;
                                    } else if (blocking_type === 'new_blocking') {
                                        url += `Pro/Calendar/Blocking/Edit/${from}/${to}/${_resource.id}/${$('select[name=TimeZone] option:selected').val()}`;
                                    }
                                    window.location.href = url;
                                    break;
                                case 'shop':
                                    url += `Pro/Calendar/Shop/Booking/Edit/${from}/${to}/${_resource.id}/${$('select[name=TimeZone] option:selected').val()}`;
                                    window.location.href = url;
                                    break;
                            }
                        }
                    };
                })(start, end, resource));

                let $lesson_types = $('#lesson-types');
                let $blocking_options = $('#blocking-options');

                $('input[name="appointment_type"]').off('change').on('change', (function (_start, _end, _resource) {
                    return function () {
                        if (this.checked) {
                            let delay = 0;

                            if (this.value === 'blocking') {
                                $("#newAppointmentTime-time-end").html(_end.format('H:mm'));
                                if ($lesson_types.hasClass('expanded')) {
                                    delay = 200;
                                    $lesson_types.removeClass('expanded');
                                }
                            } else if (this.value === 'lesson') {
                                $('select[name="lesson"]').trigger('change');
                                if ($blocking_options.hasClass('expanded')) {
                                    delay = 200;
                                    $blocking_options.removeClass('expanded');
                                }
                            } else if (this.value === 'group_lesson') {
                                $("#newAppointmentTime-time-end").empty();
                            } else if (this.value === 'shop') {
                                $("#newAppointmentTime-time-end").empty();
                            }

                            let _this = this;
                            setTimeout(function () {
                                $lesson_types.toggleClass('expanded', _this.value === 'lesson');
                                $blocking_options.toggleClass('expanded', _this.value === 'blocking');
                            }, delay);

                            var $self = $(this);

                            if ($self.hasClass('no-submit')) {
                                $self.parents('#createNewAppointmentModal').find('.ok-button').attr('disabled', true);
                            } else {
                                $self.parents('#createNewAppointmentModal').find('.ok-button').removeAttr('disabled');
                            }
                        }
                    };
                })(start, end, resource)).trigger('change');
            },
            resources: function (callback) {
                if ($('select[name="resources"] option:selected').length) {
                    var startDate = new Date();
                    _.loading.resources.lastestFetchDate = new Date(startDate.valueOf());
                    _.loading.resources.isFetching = true;
                    let _calendar = $(calendarID);

                    $.ajax({
                        url: '/Calendar/GetResourcesSettings?' + $.param(fetchResourcesParams()),
                        type: 'POST',
                        dataType: 'json',
                        async: true,
                        complete: function (data) {
                            if (data && data.responseJSON) {
                                _calendar.fullCalendar('option', data.responseJSON);
                                let view = _calendar.fullCalendar('getView');

                                setTimeout(() => {
                                    $.ajax({
                                        url: '/Calendar/GetResources?'
                                            + $.param($.extend(fetchResourcesParams(), fetchLocationsParams()))
                                            + '&start=' + gb.date.toSortable(view.start.toDate())
                                            + '&end=' + gb.date.toSortable(view.end.toDate())
                                            + '&timezone=' + $('select[name=TimeZone] option:selected').val(),
                                        type: 'POST',
                                        dataType: 'json',
                                        complete: function (data) {
                                            console.log(`calendar@resources loaded`);
                                            if (+(_.loading.resources.lastestFetchDate) === +startDate) { // This is the latest request
                                                if (data && data.status === 200 && data.responseJSON) {
                                                    let resources = data.responseJSON;
                                                    let bgEvents = [];
                                                    for (let i = 0; i < resources.length; i++) {
                                                        let res = resources[i];
                                                        if (res.children && res.children.length) {
                                                            for (let j = 0; j < res.children.length; j++) {
                                                                let loc_businesshours = res.children[j].businessHours;
                                                                res.businessHours = res.businessHours.concat(loc_businesshours);
                                                                if (isAdmin) {
                                                                    for (let k = 0; k < loc_businesshours.length; k++) {
                                                                        let bg_event = loc_businesshours[k];
                                                                        let _color = bg_event.color ? bg_event.color : (backgroundColors.length > j ? backgroundColors[j] : null);

                                                                        bgEvents.push({
                                                                            id: 'availability',
                                                                            locationId: bg_event.locationId,
                                                                            locationName: bg_event.locationName,
                                                                            start: bg_event.startAsISO,
                                                                            end: bg_event.endAsISO,
                                                                            color: _color,
                                                                            rendering: 'background',
                                                                            resourceId: res.id,
                                                                            overlap: true
                                                                        });

                                                                        $('.location-identity[data-location="' + bg_event.locationId + '"] .location-identity-color').css('background-color', _color);
                                                                    }
                                                                } else if (!isAdmin) {
                                                                    let moment_now = moment().stripZone();
                                                                    res.businessHours = res.businessHours.filter(e => { return (moment(e.endAsISO).diff(moment_now) > 0); });
                                                                }
                                                            }
                                                            res.children = []; // We dont support locations yet
                                                        } else if (res.businessHours && res.businessHours.length) {
                                                            for (let k = 0; k < res.businessHours.length; k++) {
                                                                let bg_event = res.businessHours[k];
                                                                let _color = bg_event.color ? bg_event.color : (backgroundColors.length > j ? backgroundColors[j] : null);

                                                                bgEvents.push({
                                                                    id: 'availability',
                                                                    locationId: bg_event.locationId,
                                                                    locationName: bg_event.locationName,
                                                                    start: bg_event.startAsISO,
                                                                    end: bg_event.endAsISO,
                                                                    color: _color,
                                                                    rendering: 'background',
                                                                    resourceId: res.id
                                                                });

                                                                $('.location-identity[data-location="' + bg_event.locationId + '"] .location-identity-color').css('background-color', _color);
                                                            }
                                                        }

                                                        if (!res.businessHours || !res.businessHours.length) {
                                                            res.businessHours = { // no availability
                                                                dow: [0, 1, 2, 3, 4, 5, 6],
                                                                start: '24:00',
                                                                end: '00:00'
                                                            };
                                                        }
                                                    }
                                                    _calendar.fullCalendar('removeEvents', e => e.id === 'availability');
                                                    if (bgEvents) {
                                                        _calendar.fullCalendar('renderEvents', bgEvents);
                                                    }
                                                    callback(data.responseJSON);
                                                    setTimeout(() => { _.loading.update(); }, 1); // Lag is to wait for view rendering
                                                }
                                            }

                                            setTimeout(() => { _.eventSources.update(_calendar, view.start.toDate(), view.end.toDate()); }, 1);
                                        }
                                    });
                                }, 1);
                            }
                            _.loading.resources.isFetching = false;
                        }
                    });
                }
            },
            eventRender: function (event, element, view) {
                if (event.id && event.rendering !== 'background') {
                    element.data('id', event.id).attr('data-id', event.id);

                    let _is = {
                        course: false,
                        lesson: false,
                        blocking: false,
                        shop: false,
                        lock: false
                    };

                    if (view.type === 'list' ||
                        view.type === 'gbListDay' ||
                        view.type === 'gbListWeek') {
                        let fc_wrapper = $('<td class="fc-list-content-wrapper fc-widget-content"></td>');

                        let fc_list_item_col = $('<div class="fc_list_item_col"></div>');
                        let fc_title = element.find(".fc-list-item-title").detach();
                        fc_title = $('<div class="fc-list-item-title">' + fc_title.html() + '</div>');

                        if (event.bu_resources) {
                            fc_title.append("<div class=\"fc-list-item-resources\">" + event.bu_resources.map(e => e.name).join(', ') + "</div>");
                        }

                        fc_wrapper.append(fc_title);

                        if (event.locationName) {
                            fc_wrapper.append('<div class="fc-list-item-location"' + (event.locationColor ? ' style="color: ' + event.locationColor + ';"' : '') + '>' + event.locationName + '</div>');
                        }

                        let event_icon = $('<div class="fc-list-item-icon"></div>');
                        if (event.className.any(e => e === 'shop-event')) {
                            _is.shop = true;
                            event_icon.addClass('icon-payment_register');
                        } else if (event.className.any(e => e === 'lesson-event')) {
                            _is.lesson = true;
                            event_icon.addClass('icon-golf_iron');
                            if (event.unreadMessage) {
                                element.addClass('unread-message');
                            }
                        } else if (event.className.any(e => e === 'course-event')) {
                            _is.course = true;
                            event_icon.addClass('icon-golf_bag');
                        } else if (event.className.any(e => e === 'blocking-event')) {
                            _is.blocking = true;
                            event_icon.addClass('icon-mini_no');
                        } else if (event.className.any(e => e === 'lock-event')) {
                            _is.lock = true;
                            event_icon.addClass('icon-padlock_locked');
                        }

                        if (_is.course | _is.lesson) { // Add participants
                            if (event.participants) {
                                let event_participants = $('<ul class="fc-list-item-participants column-' + Math.min(3, parseInt((event.participants.length + 1) / 2)) + '"></ul>');

                                for (let i = 0; i < event.participants.length; i++) {
                                    let par = event.participants[i];
                                    let wrapper = $('<li class="fc-list-item-participant"></li>');
                                    let name = $('<span class="fc-list-item-participant-name">' + par.name + '</span>');

                                    if (economyEnabled) {
                                        wrapper.append($('<span class="fc-list-item-participant-status ' + (par.isPaid ? 'paid' : 'unpaid') + '"></span>'));
                                    }

                                    wrapper.append(name);
                                    event_participants.append(wrapper);
                                }

                                event_participants.insertAfter(fc_title);
                            }
                        }

                        fc_wrapper.append(event_icon);
                        element.append(fc_wrapper);
                    } else {
                        let fc_content = $('.fc-content', element);
                        let fc_time = $('.fc-time', fc_content);
                        let fc_title = $('.fc-title', element);
                        let event_icon = $('<div class="fc-event-icon"></div>');

                        if (event.className.any(e => e === 'shop-event')) {
                            _is.shop = true;
                            event_icon.addClass('icon-payment_register');

                            if (!event.className.any(e => e === 'non-selectable')) {
                                fc_title.remove();

                                let fc_event_top = $('<div class="fc-event-top"></div>');
                                let fc_event_top_left = $('<div class="fc-event-top-left"></div>');
                                let fc_event_top_right = $('<div class="fc-event-top-right"></div>');

                                fc_event_top.append(fc_event_top_left);
                                fc_event_top.append(fc_event_top_right);

                                fc_event_top_right.append(event_icon);

                                if (event.bu_resources) {
                                    for (let i = 0; i < event.bu_resources.length; i++) {
                                        let event_resource = $('<div class="fc-event-resource"></div>');
                                        let res = event.bu_resources[i];

                                        event_resource.append('<img src="' + res.image + '" class="fc-event-resource-portrait"></img>');
                                        event_resource.append('<a href="/Pro/Setup/Staff/Edit/' + res.id + '" class="fc-event-resource-name">' + res.name + '</a>');
                                        fc_event_top_left.append(event_resource);
                                    }
                                }

                                fc_content.prepend(fc_event_top);
                            } else {
                                fc_content.prepend(event_icon);
                            }
                        } else if (event.className.any(e => e === 'lesson-event')) {
                            _is.lesson = true;

                            if (event.unreadMessage) {
                                element.addClass('unread-message');
                            } else {
                                event_icon.addClass('icon-golf_iron');
                                fc_content.prepend(event_icon);
                            }
                        } else if (event.className.any(e => e === 'course-event')) {
                            _is.course = true;
                            event_icon.addClass('icon-golf_bag');
                            fc_content.prepend(event_icon);
                        } else if (event.className.any(e => e === 'blocking-event')) {
                            _is.blocking = true;
                            event_icon.addClass('icon-mini_no');
                            fc_content.prepend(event_icon);

                            if (event.description) {
                                let txt = document.createElement('textarea');
                                txt.innerHTML = event.description;

                                $('<div class="fc-title">' + txt.value + '</div>').insertAfter(fc_title);
                            }
                        } else if (event.className.any(e => e === 'lock-event')) {
                            _is.lock = true;
                            event_icon.addClass('icon-padlock_locked');
                            fc_content.prepend(event_icon);
                        }

                        if (!_is.shop || event.className.any(e => e === 'non-selectable')) {
                            fc_time.detach().insertAfter(fc_title);
                        }

                        if (_is.course | _is.lesson) { // Add participants
                            if (event.participants) {
                                let event_participants = $('<div class="fc-event-participants"></div>');

                                for (let i = 0; i < event.participants.length; i++) {
                                    let par = event.participants[i];
                                    let wrapper = $('<div class="fc-event-participant"></div>');
                                    let name = $('<span class="fc-event-participant-name">' + par.name + '</span>');

                                    if (economyEnabled) {
                                        wrapper.append($('<span class="fc-event-participant-status ' + (par.isPaid ? 'paid' : 'unpaid') + '"></span>'));
                                    }

                                    wrapper.append(name);
                                    event_participants.append(wrapper);
                                }

                                event_participants.insertAfter(event_icon);
                            }
                        }
                    }
                } else if (event.id && event.rendering === 'background' && event.id === 'availability') {
                    element.data({
                        'locationId': event.locationId,
                        'locationName': event.locationName
                    }).attr({
                        'locationId': event.locationId,
                        'locationName': event.locationName
                    });
                }
            },
            viewRender: function (view, element) {
                var header = view.calendar.header.el[0];

                if (header) {
                    var filterToolbar = $('.fc-toolbar-filter');
                    if (!filterToolbar || !filterToolbar.length) {
                        filterToolbar = $('<div class="fc-toolbar fc-header-toolbar fc-toolbar-filter"></div>');
                        filterToolbar.insertAfter(header);
                        filterToolbar.append((calendarFilters || (calendarFilters = $('#calendar-filters').detach())).children());

                        var $resource_filter = $('select[name="resources"]', filterToolbar);

                        if ($resource_filter.hasClass('highlight')) {
                            $resource_filter[0].scrollIntoView();
                        }
                    }

                    if (isAdmin) {
                        var calendarSettings = $('.fc-calendar-settings', header);
                        if (!calendarSettings || !calendarSettings.length) {
                            calendarSettings = $('<button onclick="$(\'#calendarSettings\').removeClass(\'hidden\');" type="button" class="fc-button fc-state-default fc-corner-left fc-corner-right fc-calendar-settings"><span class="gb-icon icon-settings_cog_wheel"></span></button>');
                            $('.fc-right', header).prepend(calendarSettings);
                        }

                        var scaleOption = $('.fc-scale-option', header);
                        if (!scaleOption || !scaleOption.length) {
                            scaleOption = $('<button onclick="$(\'#calendar\').toggleClass(\'fullscreen\');" type="button" class="fc-button fc-state-default fc-corner-left fc-corner-right fc-scale-option"><span class="gb-icon"></span></button>');
                            $('.fc-right', header).prepend(scaleOption);
                        }
                    }
                }

                var weekNumberTitle = $('.fc-week-number span, .fc-week-number a', view.calendar.el);
                if (weekNumberTitle && weekNumberTitle.length) {
                    for (var i = 0; i < weekNumberTitle.length; i++) {
                        var weekNumberPart = $(weekNumberTitle[i]).html().match(/\d*$/);
                        $(weekNumberTitle[i]).html(translator.translate('week', 'Week') + ' ' + weekNumberPart);
                    }
                }

                if (view.type === 'list' ||
                    view.type === 'gbListDay' ||
                    view.type === 'gbListWeek') {

                    var titleParts = view.title.split(' ');
                    var weekNo = titleParts.pop(); // Week is last

                    view.title = titleParts.join(' ') + '&nbsp;&nbsp;<span class="fc-title-week">(' + translator.translate('week', 'Week') + ' ' + weekNo + ')</span>';

                    if (header) {
                        $('.fc-center h2', header).html(view.title);
                    }
                    $('.locations-list').addClass('hidden');
                } else {
                    $('.locations-list').removeClass('hidden');
                }

                if (!element.find('.loadingSpinner').length) {
                    element.prepend(gb.ui.spinner.create());
                }

                setTimeout(function () { $(document).trigger('scroll'); }, 100); // Sticky header
            },
            resourceRender: function (resourceObj, labelTds, bodyTds) {
                labelTds.on('click', function () {
                    $('select[name="resources"]').val(labelTds.data('resourceId')).trigger('change');
                });

                if ($(calendarID).fullCalendar('option', 'groupByResource') || ($(calendarID).fullCalendar('option', 'groupByDateAndResource') && $(calendarID).fullCalendar('getView').name === 'agendaDay')) {
                    var bgs = $('.fc-bg td.fc-day', calendarID);
                    var last_resource = null;
                    for (var i = 0; i < bgs.length; i++) {
                        if (last_resource === null) {
                            last_resource = $(bgs[i]).data('resource-id');
                        } else if (last_resource != $(bgs[i]).data('resource-id')) {
                            last_resource = $(bgs[i]).addClass('alternate-border').data('resource-id');
                        }
                    }
                }
            },
            eventDrop: function (event, delta, revertFunc, jsEvent, ui, view) {
                $.ajax({
                    url: '/Calendar/UpdateAppointment',
                    type: 'POST',
                    data: {
                        id: event.id,
                        deltaAsMinutes: delta.asMinutes(),
                        resources: (event.resourceIds ? event.resourceIds.join(',') : event.resourceId)
                    },
                    success: function (data) {
                        let status = "";
                        let message = "";
                        if (data.success) {
                            status = "success";
                            message = "<span style=\"position: relative; top: 50%; margin-top: -12px; font: 24px/1 gb_font;\" class=\"gb-icon icon-mini_ok\"></span>";
                        } else {
                            status = "error";
                            message = "<span style=\"font: 12px/1 gb_font;\" class=\"icon-mini_attention\"></span>";
                            message += data.message;
                            revertFunc();
                        }

                        let element = $('.fc-event[data-id="' + event.id + '"]');

                        element.prepend('<div class="fc-event-message">' + message + '</div>');
                        element.addClass((!data.success ? 'expanded ' : '') + status);

                        setTimeout(function () {
                            element.removeClass('fc-state-hover error success expanded').find('.fc-event-message').remove();
                        }, data.success ? 2200 : 6000);
                    },
                    fail: function (data) {
                        revertFunc();
                    }
                });
            },
            eventDragStart: function (event, jsEvent, ui, view) {
                let org = $('.fc-event[data-id="' + event.id + '"]');
                let ghost = org.clone(true).addClass('ghost').removeClass('fc-state-hover');
                ghost.css('bottom', ghost.data('bottom'));
                ghost.insertAfter(org);
                $(calendarID).addClass('dragging');
            },
            eventDragStop: function (event, jsEvent, ui, view) {
                $(calendarID).removeClass('dragging');
                $('.fc-event.ghost[data-id="' + event.id + '"]').remove();
            },
            weekNumberCalculation: 'ISO',
            //snapDuration: { minutes: 5 },

            // Settings chosen by current profile
            groupByResource: true,
            groupByDateAndResource: false,
            weekNumbers: true,
            nowIndicator: true,

            // Dynamic settings by resources chosen
            minTime: '00:00:00',
            maxTime: '24:00:00',
            slotDuration: '00:30:00'
        };
    };
    var extendLocales = function (culture) {
        var _24Hformat = 'HH:mm';
        var _12Hformat = 'hh:mma';

        culture = culture.toLowerCase();

        FullCalendar.locales['da']['slotLabelFormat'] = _24Hformat;

        if (!(culture in FullCalendar.locales) && culture.split('-')[0] in FullCalendar.locales) {
            culture = culture.split('-')[0];
        }

        if (/H/.test(FullCalendar.locales[culture].hourFormat)) {
            FullCalendar.locales[culture]['slotLabelFormat'] = _24Hformat;
        } else {
            FullCalendar.locales[culture]['slotLabelFormat'] = _12Hformat;
            FullCalendar.locales[culture]['timeFormat'] = 'hh:mma';
        }

        return culture;
    };
    let dragging = false; // Used for touch devices

    _.init = function (id, options, _isAdmin, _culture, _economyEnabled) {
        isAdmin = _isAdmin;
        economyEnabled = _economyEnabled;
        var extendedCalendarOptions = $.extend(true, {}, calendarOptions(id), options);
        extendedCalendarOptions.locale = extendLocales(_culture);
        _.loading.calendar = id;
        var $calendar = null;
        $(document).ready(function () {
            var init = null;
            init = setInterval(function () {
                try {
                    $calendar = $(id).fullCalendar(extendedCalendarOptions);
                    clearInterval(init);
                } catch (error) {
                    console.dir(error);
                }
            }, 100);
        }).on('mouseenter', 'select[name="resources"]', function () {
            if (isAdmin && !gb.isTouch()) {
                var $self = $(this);
                var size = 0;
                var optgroups = $('optgroup', $self);
                var options = $('option', $self);

                if (optgroups && optgroups.length) {
                    size += optgroups.length;
                }

                if (options && options.length) {
                    size += options.length;
                }

                $self.css('height', (size * 18) + 'px');
            }
        }).on('mouseleave', 'select[name="resources"]', function () {
            var $self = $(this);
            if (isAdmin && !gb.isTouch()) {
                $self.css('height', '');
            }
            setTimeout(function () {
                $self.trigger('scrollTo');
            }, 500);
        }).on('blur scrollTo', 'select[name="resources"]', function () {
            let resource_selected = $(this).find('option:selected');
            if (resource_selected && resource_selected.length) {
                this.scrollTop = $(this).find('option:selected')[0].offsetTop;
            }
        }).on('change', 'input[name="Date"]', function () {
            $calendar.fullCalendar('gotoDate', this.value);
        }).on('mouseenter mouseleave touchend', id + ':not(.dragging) .fc-event:not(.expanded)', function (dom_event) {
            var $this = $(this);
            // Don't do anything if touchend is fired after dragging by touch
            if (dom_event.type === 'touchend' && dragging) {
                return;
            }

            if (dom_event && dom_event.type === 'touchend') {
                $('.fc-event.fc-state-hover', id).not(this).trigger('mouseleave');

                if (!$this.hasClass('fc-state-hover')) {
                    dom_event.preventDefault(); // This is preventing touch from firing click event
                    setTimeout(function () {
                        $this.trigger('mouseleave');
                    }, 4000);
                }
            }

            var calculated_height = null;
            var true_height = null;
            var bottom = null;

            if (!$this.data("calculated_height")) {
                calculated_height = parseFloat($this.height());
                true_height = parseFloat($this.find('.fc-content').height());
                bottom = $this.css('bottom');

                $this.data({
                    'calculated_height': calculated_height,
                    'true_height': true_height,
                    'bottom': bottom
                });
            } else {
                calculated_height = $this.data('calculated_height');
                true_height = $this.data('true_height');
                bottom = $this.data('bottom');
            }

            if (dom_event.type === 'mouseenter' || dom_event.type === 'touchend') {
                $this.addClass('fc-state-hover').parent().addClass('active');

                if (true_height > calculated_height) {
                    $this.css('bottom', '-=' + (true_height - calculated_height));
                }
            } else {
                $this.removeClass('fc-state-hover').parent().removeClass('active');

                if (true_height > calculated_height) {
                    $this.css('bottom', bottom);
                }
            }
        }).on('mousedown', '.fc-calendar-settings, .fc-scale-option', function () {
            $(this).addClass('fc-state-down');
        }).on('mouseup mouseout', '.fc-calendar-settings, .fc-scale-option', function () {
            $(this).removeClass('fc-state-down');
        }).on('click', '.fc-prev-button, .fc-next-button', function () {
            $calendar.fullCalendar('refetchResources');
            var _moment = $calendar.fullCalendar('getDate');
            $('input[name="Date"] + input.datepicker').datepicker('setDate', _moment.toDate());
        }).on('click', '.fc-timelineDay-button, .fc-agendaDay-button, .fc-agendaTwoDay-button, .fc-agendaWeek-button, .fc-month-button, .fc-gbListDay-button, .fc-gbListWeek-button, .fc-week-number span, .fc-week-number a, .fc-day-header a, .fc-resource-cell', function () {
            $calendar.fullCalendar('refetchResources');
            $calendar.fullCalendar('refetchEvents');
        }).on('change', 'select[name="resources"], select[name="locations"], input[name="Date"], select[name="TimeZone"]', function () {
            $calendar.fullCalendar('refetchResources');
            $calendar.fullCalendar('refetchEvents');
        }).on('mouseup', '.fc-today-button:not(.fc-state-disabled)', function () {
            setTimeout(function () {
                $calendar.fullCalendar('refetchResources');
                var _moment = $calendar.fullCalendar('getDate');
                $('input[name="Date"] + input.datepicker').datepicker('setDate', _moment.toDate());
                $('.fc-today-button').trigger('save-filters');
            }, 100);
        }).on('click', '.fc-agendaWeek-button, .fc-week-number span, .fc-week-number a, .fc-day-header a, .fc-resource-cell', function () {
            var _moment = $calendar.fullCalendar('getDate');
            $('input[name="Date"] + input.datepicker').datepicker('setDate', _moment.toDate());
        });

        $(document).add(id).on('scroll load resize', (function () {
            let oldVisible = null;

            return function () {
                let table_header = $('thead.fc-head:eq(0)', $calendar);
                let placeholder = $('#sticky-header-placeholder');

                if (!placeholder.length) {
                    placeholder = $('<div class="hidden" id="sticky-header-placeholder"></div>').css({ height: table_header.outerHeight() });
                    placeholder.insertBefore(table_header);
                }

                if (table_header.length && placeholder.length) {
                    let visible = false;

                    if (table_header.hasClass('sticky')) {
                        visible = gb.ui.position(placeholder).visible();
                    } else {
                        visible = gb.ui.position(table_header).visible();
                    }

                    if (visible !== oldVisible || (!table_header.hasClass('sticky') && !visible)) {
                        oldVisible = visible;

                        placeholder.css({ height: table_header.outerHeight() });

                        placeholder.toggleClass('hidden', visible);
                        table_header.toggleClass('sticky', !visible);

                        if (!visible) {
                            table_header.css({ width: placeholder.outerWidth() });
                        } else {
                            table_header.css({ width: '' });
                        }
                    }
                }
            };
        })());

        // Used to prevent "hover" on touch devices after scrolling
        $(document).on("touchmove", function () {
            dragging = true;
        }).on("touchstart", function () {
            dragging = false;
        });
    };
}();